import isNil from 'lodash/isNil';
import { mapGetters } from 'vuex';
import { providerTypeEnum } from '@enums/user-enum';

export default {
  name: 'enquire-modal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    uuid: {
      type: String,
      default: null,
    },
    confirmCallback: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      submitError: false,
    };
  },
  computed: {
    ...mapGetters({
      getOfferByUuid: 'connector/getOfferByUuid',
    }),

    offer() {
      return this.getOfferByUuid(this.uuid);
    },

    providerFirstName() {
      if (isNil(this.offer)) {
        return null;
      }

      return this.offer.fsp.user.first_name;
    },

    providerOrganisationName() {
      if (isNil(this.offer)) {
        return null;
      }

      return this.offer.fsp.organisation.name;
    },

    isBroker() {
      if (isNil(this.offer)) {
        return false;
      }

      return this.offer.fsp.provider_type === providerTypeEnum.BROKER;
    },
  },
  methods: {
    toggleModal() {
      this.$emit('update:isOpen', !this.isOpen);
    },
    confirm() {
      this.isLoading = true;
      this.submitError = false;

      return this.confirmCallback()
        .then(() => {
          this.isLoading = false;
          this.toggleModal();
        })
        .catch(() => {
          this.isLoading = false;
          this.submitError = true;
        });
    },
  },
};
